
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.25 10a8.75 8.75 0 1017.501-.001A8.75 8.75 0 001.25 10zm12.074-3.23l-.006 1.289L11.004 10l2.312 1.94.006 1.29a.155.155 0 01-.156.157.162.162 0 01-.101-.037l-3.028-2.541-3.025 2.54a.157.157 0 01-.258-.12l.006-1.29L9.074 10 6.762 8.06l-.006-1.289c0-.085.068-.156.156-.156.037 0 .072.014.102.037l3.025 2.537 3.027-2.539a.157.157 0 01.258.12z","opacity":".5"}})])
          )
        }
      }
    